import { colorsPalettes } from "@similarweb/styles";

export const CONVERSION_RATES_TAB_NAME = "ConversionRates";

export const POP_CURRENT_COLOR = colorsPalettes.blue[400];
export const POP_PREVIOUS_COLOR = colorsPalettes.orange[400];
